var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("p", { staticClass: "mt20", attrs: { "data-test": "employment" } }, [
        _vm._v(
          "\n    " + _vm._s(_vm.requirements.employment.join(" ")) + "\n  "
        ),
      ]),
      _vm._v(" "),
      _vm.requirements.employmentRemarks
        ? _c("p", {
            staticClass: "mt10 pega-pre-wrap",
            attrs: { "data-test": "employmentRemarks" },
            domProps: {
              textContent: _vm._s(_vm.requirements.employmentRemarks),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.requirements.regular
        ? _c(
            "dl",
            {
              staticClass: "bg-blue-box mt15",
              attrs: { "data-test": "regular" },
            },
            [
              _c("dt", [_vm._v("正社員登用について")]),
              _vm._v(" "),
              _c("dd", {
                staticClass: "pega-pre-wrap",
                domProps: { textContent: _vm._s(_vm.requirements.regular) },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("p", {
        staticClass: "mt20 pega-pre-wrap",
        attrs: { "data-test": "salary" },
        domProps: { textContent: _vm._s(_vm.requirements.salary) },
      }),
      _vm._v(" "),
      _vm.requirements.salaryEx
        ? _c(
            "dl",
            {
              staticClass: "bg-blue-box mt15",
              attrs: { "data-test": "salaryEx" },
            },
            [
              _c("dt", [_vm._v("給与例")]),
              _vm._v(" "),
              _c("dd", {
                staticClass: "pega-pre-wrap",
                domProps: { textContent: _vm._s(_vm.requirements.salaryEx) },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.requirements.isBulkRegistrationAddress && _vm.isMultiLineValue
        ? _c(
            "dl",
            {
              staticClass: "bg-blue-box mt15",
              attrs: { "data-test": "isBulkRegistrationSalaryAddress" },
            },
            [
              _c("dt", [_vm._v("勤務地別給与")]),
              _vm._v(" "),
              _c("dd", {
                staticClass: "pega-pre-wrap pega-preview-word-break",
                domProps: {
                  textContent: _vm._s(
                    _vm.requirements.combinedAllSalaryBulkPlace
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c("p", {
        staticClass: "mt20 pega-pre-wrap",
        attrs: { "data-test": "place" },
        domProps: { textContent: _vm._s(_vm.requirements.place) },
      }),
      _vm._v(" "),
      _vm.requirements.transportation
        ? _c(
            "dl",
            {
              staticClass: "bg-blue-box mt15",
              attrs: { "data-test": "transportation" },
            },
            [
              _c("dt", [_vm._v("詳細・交通")]),
              _vm._v(" "),
              _c("dd", {
                staticClass: "pega-pre-wrap",
                domProps: {
                  textContent: _vm._s(_vm.requirements.transportation),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.requirements.transfer
        ? _c(
            "dl",
            {
              staticClass: "bg-blue-box mt10",
              attrs: { "data-test": "transfer" },
            },
            [
              _c("dt", [_vm._v("転勤の可能性")]),
              _vm._v(" "),
              _c("dd", {
                staticClass: "pega-pre-wrap",
                domProps: { textContent: _vm._s(_vm.requirements.transfer) },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.requirements.isBulkRegistrationAddress &&
      _vm.requirements.combinedAllBulkPlace
        ? _c("job-preview-content-sub-work-location-sp", {
            attrs: {
              "is-bulk-registration-address":
                _vm.requirements.isBulkRegistrationAddress,
              "value-bulk-place": _vm.requirements.combinedAllBulkPlace,
              "data-test": "combinedAllBulkPlace",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.requirements.isBulkRegistrationAddress
        ? _c("job-preview-content-sub-work-location-sp", {
            attrs: {
              "work-location": _vm.requirements.workLocation,
              "is-bulk-registration-address":
                _vm.requirements.isBulkRegistrationAddress,
              "data-test": "workLocation",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _c("p", {
        staticClass: "mt20 pega-pre-wrap",
        attrs: { "data-test": "requiredSkill" },
        domProps: { textContent: _vm._s(_vm.requirements.requiredSkill) },
      }),
      _vm._v(" "),
      _vm.requirements.welcomeSkill
        ? _c(
            "dl",
            {
              staticClass: "bg-blue-box mt15",
              attrs: { "data-test": "welcomeSkill" },
            },
            [
              _c("dt", [_vm._v("あると望ましい経験・能力")]),
              _vm._v(" "),
              _c("dd", {
                staticClass: "pega-pre-wrap",
                domProps: {
                  textContent: _vm._s(_vm.requirements.welcomeSkill),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.requirements.recruitExample
        ? _c(
            "dl",
            {
              staticClass: "bg-blue-box mt10",
              attrs: { "data-test": "recruitExample" },
            },
            [
              _c("dt", [_vm._v("過去に採用した転職者例")]),
              _vm._v(" "),
              _c("dd", {
                staticClass: "pega-pre-wrap",
                domProps: {
                  textContent: _vm._s(_vm.requirements.recruitExample),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isShow.post
        ? [
            _vm._m(4),
            _vm._v(" "),
            _vm.requirements.post
              ? _c("p", {
                  staticClass: "mt20 pega-pre-wrap",
                  attrs: { "data-test": "post" },
                  domProps: { textContent: _vm._s(_vm.requirements.post) },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.requirements.ageRatio
              ? _c(
                  "dl",
                  {
                    staticClass: "bg-blue-box mt10",
                    class: { mt20: !_vm.requirements.post },
                    attrs: { "data-test": "ageRatio" },
                  },
                  [
                    _c("dt", [_vm._v("年齢構成")]),
                    _vm._v(" "),
                    _c("dd", {
                      staticClass: "pega-pre-wrap",
                      domProps: {
                        textContent: _vm._s(_vm.requirements.ageRatio),
                      },
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.requirements.sexRatio
              ? _c(
                  "dl",
                  {
                    staticClass: "bg-blue-box mt10",
                    class: {
                      mt20:
                        !_vm.requirements.post && !_vm.requirements.ageRatio,
                    },
                    attrs: { "data-test": "sexRatio" },
                  },
                  [
                    _c("dt", [_vm._v("男女比")]),
                    _vm._v(" "),
                    _c("dd", {
                      staticClass: "pega-pre-wrap",
                      domProps: {
                        textContent: _vm._s(_vm.requirements.sexRatio),
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._m(5),
      _vm._v(" "),
      _c("p", {
        staticClass: "mt20 pega-pre-wrap",
        attrs: { "data-test": "officeHours" },
        domProps: { textContent: _vm._s(_vm.requirements.officeHours) },
      }),
      _vm._v(" "),
      _vm.requirements.overTime
        ? _c(
            "dl",
            {
              staticClass: "bg-blue-box mt15",
              attrs: { "data-test": "overTime" },
            },
            [
              _c("dt", [_vm._v("残業について")]),
              _vm._v(" "),
              _c("dd", {
                staticClass: "pega-pre-wrap",
                domProps: { textContent: _vm._s(_vm.requirements.overTime) },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.requirements.mother
        ? [
            _vm._m(6),
            _vm._v(" "),
            _c("p", {
              staticClass: "mt20 pega-pre-wrap",
              attrs: { "data-test": "mother" },
              domProps: { textContent: _vm._s(_vm.requirements.mother) },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._m(7),
      _vm._v(" "),
      _c("p", {
        staticClass: "mt20 pega-pre-wrap",
        attrs: { "data-test": "vacation" },
        domProps: { textContent: _vm._s(_vm.requirements.vacation) },
      }),
      _vm._v(" "),
      _vm.requirements.maternity
        ? _c(
            "dl",
            {
              staticClass: "bg-blue-box mt15",
              attrs: { "data-test": "maternity" },
            },
            [
              _c("dt", [_vm._v("産休育休活用例")]),
              _vm._v(" "),
              _c("dd", {
                staticClass: "pega-pre-wrap",
                domProps: { textContent: _vm._s(_vm.requirements.maternity) },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(8),
      _vm._v(" "),
      _c("p", {
        staticClass: "mt20 pega-pre-wrap",
        attrs: { "data-test": "condition" },
        domProps: { textContent: _vm._s(_vm.requirements.condition) },
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "hd-type-0n3" }, [
      _c("span", [_vm._v("雇用形態")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "hd-type-0n3" }, [
      _c("span", [_vm._v("給与")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "hd-type-0n3" }, [
      _c("span", [_vm._v("勤務地")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "hd-type-0n3" }, [
      _c("span", [_vm._v("応募資格")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "hd-type-0n3", attrs: { "data-test": "post-head" } },
      [_c("span", [_vm._v("配属部署")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "hd-type-0n3" }, [
      _c("span", [_vm._v("勤務時間")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "hd-type-0n3", attrs: { "data-test": "mother-head" } },
      [_c("span", [_vm._v("育児と両立しやすい")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "hd-type-0n3" }, [
      _c("span", [_vm._v("休日休暇")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "hd-type-0n3" }, [
      _c("span", [_vm._v("待遇・福利厚生・その他")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }